import React, { useState, useEffect } from 'react';
import { Modal, Form, Button, Row, Col } from 'react-bootstrap';
import Select from "react-select";
import { useUpdateTicketType } from '../../../hooks/TICKET/useUpdateTicketType';
import { useColors } from '../../../hooks/COLORS/useColors';
import { customSelectStyles } from '../../../utils/reactSelectStyles';

const UpdateTypeTicket = ({ showUpdateTypeTicket, setShowUpdateTypeTicket, type }) => {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [formData, setFormData] = useState({ nom: '', label: '', couleur: null, defaut: false });

    const { mutateAsync: updateType } = useUpdateTicketType();
    const { data: colorsData, isLoading: isLoadingColors } = useColors();

    const colorOptions = colorsData?.data?.map(color => ({ value: color.id.toString(), label: color.name, hex: color.hex })) ?? [];

    useEffect(() => {
        if (type) {
            setFormData({
                nom: type.name || '',
                label: type.label || '',
                couleur: type.color?.id ? { value: type.color.id.toString(), label: type.color.name, hex: type.color.hex } : null,
                defaut: type.is_default || false
            });
        }
    }, [type]);

    const hasChanges = type && (
        formData.nom !== (type.name || '') ||
        formData.label !== (type.label || '') ||
        (formData.couleur?.value ?? null) !== (type.color?.id?.toString() ?? null) ||
        formData.defaut !== (type.is_default || false)
    );

    const formatColorOption = ({ label, hex }) => (
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <div style={{ width: '14px', height: '14px', borderRadius: '50%', backgroundColor: hex || '#e9ecef', border: '1px solid #ced4da', flexShrink: 0 }} />
            <span>{label}</span>
        </div>
    );

    const handleSubmitForm = async (e) => {
        e.preventDefault();
        if (!hasChanges) { setShowUpdateTypeTicket(false); return; }

        const typeData = {};
        if (formData.nom !== (type.name || '')) typeData.nom = formData.nom || undefined;
        if (formData.label !== (type.label || '')) typeData.label = formData.label || undefined;
        if ((formData.couleur?.value ?? null) !== (type.color?.id?.toString() ?? null)) {
            typeData.couleur = formData.couleur ? parseInt(formData.couleur.value) : null;
        }
        if (formData.defaut !== (type.is_default || false)) typeData.defaut = formData.defaut;

        setIsSubmitting(true);
        try {
            await updateType({ typeId: type.id, typeData });
            setShowUpdateTypeTicket(false);
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <Modal show={showUpdateTypeTicket} onHide={() => setShowUpdateTypeTicket(false)} size='lg'>
            <Form onSubmit={handleSubmitForm}>
                <Modal.Header closeButton>
                    <Modal.Title><h5 className='text-muted modal-title'>Modifier un type de ticket</h5></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Form.Group className="mb-3" as={Col} controlId="idNom">
                            <Form.Label className='text-muted'>Nom</Form.Label>
                            <Form.Control type="text" placeholder="Nom du type" value={formData.nom} onChange={(e) => setFormData({ ...formData, nom: e.target.value })} />
                        </Form.Group>
                        <Form.Group className="mb-3" as={Col} controlId="idLabel">
                            <Form.Label className='text-muted'>Label</Form.Label>
                            <Form.Control type="text" placeholder="Label du type" value={formData.label} onChange={(e) => setFormData({ ...formData, label: e.target.value })} />
                        </Form.Group>
                    </Row>
                    <Row>
                        <Form.Group className='mb-3' as={Col} controlId="idCouleur">
                            <Form.Label className='text-muted'>Choisissez une couleur</Form.Label>
                            <Select options={colorOptions} value={formData.couleur} formatOptionLabel={formatColorOption} onChange={(option) => setFormData({ ...formData, couleur: option })} isLoading={isLoadingColors} menuPortalTarget={document.body} styles={{ ...customSelectStyles, menuPortal: base => ({ ...base, zIndex: 9999 }) }} placeholder="Sélectionnez une couleur" isClearable />
                        </Form.Group>
                        <Form.Group className='mb-3' as={Col} controlId="previsuCouleur">
                            <Form.Label className='text-muted'>Prévisualisation</Form.Label>
                            <div style={{ height: '38px', border: '1px solid #ced4da', borderRadius: '0.375rem', backgroundColor: formData.couleur?.hex || '#e9ecef' }} />
                        </Form.Group>
                    </Row>
                    <Row>
                        <Form.Group className="mb-3" controlId="idDefaut">
                            <Form.Check type="checkbox" label="Type par défaut" checked={formData.defaut} onChange={(e) => setFormData({ ...formData, defaut: e.target.checked })} />
                        </Form.Group>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" disabled={isSubmitting} onClick={() => setShowUpdateTypeTicket(false)}>Annuler</Button>
                    <Button variant="primary" type="submit" disabled={isSubmitting || !hasChanges}>
                        {isSubmitting ? 'Chargement...' : 'Modifier'}
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
};

export default UpdateTypeTicket;